import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import { InertiaLink } from '@inertiajs/inertia-react'
import EditIcon from '@mui/icons-material/Edit'
import PageviewIcon from '@mui/icons-material/Pageview'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function VoucherRequest({ vouchersRequested }) {
  const { t } = useTranslation()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <DataGrid
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('VOUCHERS.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'merchant_name',
              Header: t('VOUCHERS.MERCHANT_NAME'),
              accessor: 'merchant_name',
              type: 'string',
            },
            {
              id: 'price',
              Header: t('VOUCHERS.PRICE'),
              accessor: 'price',
              type: 'number',
            },
            {
              id: 'expired_date',
              Header: t('VOUCHERS.EXPIRED'),
              accessor: 'expired_date',
              type: 'dateTime',
              disableFilters: true,
            },
            {
              id: 'type',
              Header: t('VOUCHER.VOUCHER_TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
              autoHide: true,
            },
            {
              id: 'status',
              Header: t('VOUCHERS.STATUS'),
              accessor: ({ status }) => t(`TABLE.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: VOUCHER_STATUS.REJECTED, name: t('VOUCHERS.REJECTED') },
                { value: VOUCHER_STATUS.REQUESTED, name: t('VOUCHERS.REQUESTED') },
              ],
              autoHide: true,
            },
            {
              id: 'actions',
              Header: t('VOUCHERS.ACTIONS'),
              disableFilters: true,
              cell: {
                style: { whiteSpace: 'nowrap' },
              },
              align: 'center',
              type: 'string',
              Cell: ({ row }) => (
                <>
                  <IconButton component={InertiaLink} href={route('merchant.vouchers.show.requested', row.original.id)}>
                    <PageviewIcon />
                  </IconButton>
                  {VOUCHER_STATUS.REQUESTED === row.original.status && (
                    <IconButton
                      component={InertiaLink}
                      href={route('merchant.vouchers.edit.requested', row.original.id)}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                  {VOUCHER_STATUS.REJECTED === row.original.status && (
                    <IconButton disabled component={InertiaLink}>
                      <EditIcon />
                    </IconButton>
                  )}
                </>
              ),
            },
          ]}
          data={vouchersRequested}
          routeName="merchant.vouchers.request"
        />
      </Grid>
    </Grid>
  )
}
